// extracted by mini-css-extract-plugin
var _1 = "content-block__Djs3h";
var _2 = "content-block-title__C1ysw";
var _3 = "content-block-wrapper__iHmz4";
var _4 = "content-card__xsDC4";
var _5 = "content-card-description__xvfyf";
var _6 = "content-card-header__VEwNu";
var _7 = "content-footer__GuJrl";
var _8 = "content-page__WcKkd";
var _9 = "content-page-desktop__VPP0A";
var _a = "content-page-mobile__btKSz";
var _b = "content-page-tablet__Hu5vO";
var _c = "content-page-thin__qyL5g";
var _d = "footer__OUhOh";
var _e = "footer-st__kHDYP";
export { _1 as "contentBlock", _2 as "contentBlockTitle", _3 as "contentBlockWrapper", _4 as "contentCard", _5 as "contentCardDescription", _6 as "contentCardHeader", _7 as "contentFooter", _8 as "contentPage", _9 as "contentPageDesktop", _a as "contentPageMobile", _b as "contentPageTablet", _c as "contentPageThin", _d as "footer", _e as "footerSt" }
